import * as React from 'react';
import TopNavBar from './TopNavBar';
import SideNavBar from './SideNavBar';
import ContentBody from './ContentBody';

//Layout of top, side and main section
export default class Layout extends React.PureComponent<{}, { children?: React.ReactNode }> {
	public render() {
		return (
			<React.Fragment>
				<div style={{
					display: 'flex',
					height: '95vh'
				}}>
					<TopNavBar />
					<SideNavBar />
					<ContentBody children={this.props.children} />
				</div>
			</React.Fragment>
		);
	}
}